const CustomCohab9 = () => import('@/views/custom/consorciocohab9/ConsorcioCohab9')
const CustomCohab9Form = () => import('@/views/custom/consorciocohab9/ConsorcioCohab9Form')


export default {
    remove: [

    ],
    routes: [
        {
            path: '/custom/checklist/cohab/view/:id',
            name: 'custom-consorciocohab9-checklist-cohab-form-view',
            component: CustomCohab9Form
        }, {
            path: '/custom/checklist/cohab/:id',
            name: 'custom-consorciocohab9-checklist-cohab-form',
            component: CustomCohab9Form
        },
        {
            path: '/custom/checklist/cohab',
            name: 'custom-consorciocohab9-checklist-cohab',
            component: CustomCohab9
        },

    ]
}
